import { Link } from "react-router-dom";
import React from "react";
import Icon from "../components/Icon";
import { WHATSAPP_URL } from "../constants/site";

export default function PricingPage() {
  return (
    <>
      <section className="relative py-16 md:py-20 page-x overflow-hidden">
        <div className="absolute inset-0 pattern-bg -z-10"></div>
        <div className="max-w-max-width mx-auto text-center">
          <span className="inline-block bg-tertiary-fixed text-on-tertiary-fixed px-4 py-1 rounded-full text-label-md font-medium mb-6">
            Invest in Your Hereafter
          </span>
          <h1 className="text-display-responsive text-primary mb-6">
            Simple Quran Class Pricing
          </h1>
          <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mx-auto">
            Choose a plan that fits your schedule and spiritual goals. Our
            celestial approach to learning ensures quality instruction at every
            level.
          </p>
        </div>
      </section>

      <section className="py-12 page-x">
        <div className="max-w-max-width mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-gutter">
            <div className="bg-surface-container-lowest rounded-2xl p-8 border border-outline-variant hover:shadow-xl transition-all duration-300 flex flex-col h-full group">
              <div className="mb-8">
                <h3 className="font-headline-md text-headline-md text-primary mb-2">
                  Starter
                </h3>
                <p className="text-on-surface-variant font-body-md">
                  Perfect for beginners.
                </p>
              </div>
              <div className="mb-8">
                <span className="text-display-lg font-bold text-primary">
                  $35
                </span>
                <span className="text-on-surface-variant">/ month</span>
              </div>
              <ul className="space-y-4 mb-10 flex-grow">
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    2 Classes per week
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    30 min sessions
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    Monthly Progress Report
                  </span>
                </li>
              </ul>
              <Link
                to="/contact?plan=starter"
                className="block w-full text-center py-3 rounded-full border-2 border-primary text-primary font-bold hover:bg-primary hover:text-on-primary transition-all"
              >
                Choose Starter
              </Link>
            </div>

            <div className="bg-surface-container-lowest rounded-2xl p-8 border-2 border-primary-container shadow-lg relative lg:-translate-y-4 transition-all duration-300 flex flex-col h-full group">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary-container text-on-primary-container px-4 py-1 rounded-full text-label-md font-bold">
                MOST POPULAR
              </div>
              <div className="mb-8">
                <h3 className="font-headline-md text-headline-md text-primary mb-2">
                  Regular
                </h3>
                <p className="text-on-surface-variant font-body-md">
                  Our standard learning pace.
                </p>
              </div>
              <div className="mb-8">
                <span className="text-display-lg font-bold text-primary">
                  $50
                </span>
                <span className="text-on-surface-variant">/ month</span>
              </div>
              <ul className="space-y-4 mb-10 flex-grow">
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    3 Classes per week
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    30 min sessions
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    Flexible Scheduling
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    Recordings Available
                  </span>
                </li>
              </ul>
              <Link
                to="/contact?plan=regular"
                className="block w-full text-center py-3 rounded-full bg-primary text-on-primary font-bold hover:opacity-90 shadow-md transition-all"
              >
                Choose Regular
              </Link>
            </div>

            <div className="bg-surface-container-lowest rounded-2xl p-8 border border-outline-variant hover:shadow-xl transition-all duration-300 flex flex-col h-full group">
              <div className="mb-8">
                <h3 className="font-headline-md text-headline-md text-primary mb-2">
                  Advanced
                </h3>
                <p className="text-on-surface-variant font-body-md">
                  Accelerated Tajweed/Hifz.
                </p>
              </div>
              <div className="mb-8">
                <span className="text-display-lg font-bold text-primary">
                  $80
                </span>
                <span className="text-on-surface-variant">/ month</span>
              </div>
              <ul className="space-y-4 mb-10 flex-grow">
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    5 Classes per week
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    30 min sessions
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    Priority Support
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    Custom Curriculum
                  </span>
                </li>
              </ul>
              <Link
                to="/contact?plan=advanced"
                className="block w-full text-center py-3 rounded-full border-2 border-primary text-primary font-bold hover:bg-primary hover:text-on-primary transition-all"
              >
                Choose Advanced
              </Link>
            </div>

            <div className="bg-surface-container-lowest rounded-2xl p-8 border border-outline-variant hover:shadow-xl transition-all duration-300 flex flex-col h-full group">
              <div className="mb-8">
                <h3 className="font-headline-md text-headline-md text-primary mb-2">
                  Family
                </h3>
                <p className="text-on-surface-variant font-body-md">
                  For up to 3 students.
                </p>
              </div>
              <div className="mb-8">
                <span className="text-display-lg font-bold text-primary">
                  $120
                </span>
                <span className="text-on-surface-variant">/ month</span>
              </div>
              <ul className="space-y-4 mb-10 flex-grow">
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    Shared Class Hours
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    60 min sessions
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                    filled
                  />
                  <span className="text-on-surface-variant font-body-md">
                    Multi-Login Access
                  </span>
                </li>
              </ul>
              <Link
                to="/contact?plan=family"
                className="block w-full text-center py-3 rounded-full border-2 border-primary text-primary font-bold hover:bg-primary hover:text-on-primary transition-all"
              >
                Choose Family
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 page-x">
        <div className="max-w-3xl mx-auto bg-surface-container-low rounded-xl p-6 border-l-4 border-tertiary">
          <div className="flex gap-4">
            <Icon
              name="info"
              className="material-symbols-outlined text-tertiary"
            />
            <p className="font-body-md text-on-surface-variant">
              <strong>Fee Note:</strong> Monthly fees may vary slightly based on
              your country of residence, currency conversion, and specific class
              duration requirements. Special discounts are available for
              long-term upfront payments.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 page-x bg-surface-container-high relative overflow-hidden">
        <div className="max-w-max-width mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
          <div className="md:w-1/2">
            <h2 className="text-headline-responsive text-primary mb-4">
              Need a Custom Plan?
            </h2>
            <p className="font-body-lg text-body-lg text-on-surface-variant mb-8">
              If our standard plans don't meet your unique needs or if you
              represent a large group, we're happy to tailor a celestial
              learning journey just for you.
            </p>
            <div className="flex flex-col xs:flex-row flex-wrap gap-3 sm:gap-4">
              <a
                className="flex items-center gap-2 bg-[#25D366] text-white px-8 py-3 rounded-full font-bold shadow-md hover:opacity-90 active:scale-95 transition-all"
                href={WHATSAPP_URL}
              >
                <Icon name="whatshot" className="material-symbols-outlined" />
                WhatsApp Us
              </a>
              <a
                className="flex items-center gap-2 bg-secondary text-on-secondary px-8 py-3 rounded-full font-bold shadow-md hover:opacity-90 active:scale-95 transition-all"
                href="/contact"
              >
                <Icon name="mail" className="material-symbols-outlined" />
                Contact Sales
              </a>
            </div>
          </div>
          <div className="md:w-1/2 relative">
            <div className="aspect-video rounded-3xl overflow-hidden shadow-2xl">
              <img
                alt="Student learning Quran"
                className="w-full h-full object-cover"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuCTTh7ECnx5s3i_3u-hzzdgU7qk5BQ0O2QifOzVq_Ic_SLnUtsyNGgl8HT1cb2h50riHeVanXV0X2ziTCznuaQ0DwMa57E9OaT28u6KCtsWh_qkrRbmcO7TsxMZ4khv18qWPq4ZEBzsts9aRQFYoTqLsHZjM0z2xUtDVsNn0bgmf3-VHFpUdPg-ODrS7jxSSINdfJBhEwcM96qBD_1hrEj5hcgJ0AKvIru-A-U4apnnMoQLHyZOgyS4YaFs6u3mF-9W0_DN_YqTd744"
              />
            </div>

            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-tertiary-fixed rounded-full -z-10 opacity-50 blur-2xl"></div>
          </div>
        </div>
      </section>
    </>
  );
}
